package com.patronat.top.features.usermanagement.di

import com.patronat.top.features.usermanagement.domain.repository.ProfileRepository
import com.patronat.top.features.usermanagement.data.network.UserRemoteDataStore
import com.patronat.top.features.usermanagement.data.repository.ProfileRepositoryImpl
import com.patronat.top.features.usermanagement.domain.usecase.*
import com.patronat.top.features.usermanagement.presentation.UsersViewModel
import com.patronat.top.features.usermanagement.presentation.create.CreateUserViewModel
import org.koin.dsl.module

val userManagementRepository = module {

    single { UserRemoteDataStore(get()) }

    single<ProfileRepository> {
        ProfileRepositoryImpl(
            userRemoteDataStore = get()
        )
    }

    single { GetUsersUseCase(userRepository = get(), dispatcherProvider = get()) }
    single { CreateUserUseCase(userRepository = get(), dispatcherProvider = get()) }
    single { UpdateUserStatusUseCase(profileRepository = get(), dispatcherProvider = get()) }
    single { GetUserByIdUseCase(profileRepository = get(), dispatcherProvider = get()) }
    single { UpdateUserUseCase(profileRepository = get(), dispatcherProvider = get()) }

    factory<UsersViewModel> {
        UsersViewModel(
            alertController = get(),
            getUsersUseCase = get(),
            updateUserStatusUseCase = get()
        )
    }
    factory<CreateUserViewModel> {
        CreateUserViewModel(
            alertController = get(),
            uploadImageUseCase = get(),
            createUserUseCase = get(),
            getUserByIdUseCase = get(),
            updateUserUseCase = get()
        )
    }
}